module.exports = __webpack_public_path__ + "media/img/corporate/newsletter-push-d3d99fadcc20cb25f980678fc7cc362b.svg";